import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import { platformHandler } from "../platforms/PlatformHandler";
import { languageManager } from "../utils/languageManager";
import { requestPostSail } from "../utils/requester";
import { setSelectedPPT } from "../App/actions";

class DialogUpload extends Component {
  render() {
    return this.props.stateLoadingPresentation ? (
      <Dialog
        open
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {languageManager.getLangWord("UPLOADING")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.props.stateLoadingPresentation}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    ) : (
      <Dialog
        open
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {languageManager.getLangWord("STATES_INIT_PRESENTATION.2")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {languageManager.getLangWord("UPLOAD_WANT_TO_START")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => this.optionDialogStartPPT(true)}
            color="secondary"
            autoFocus
          >
            {languageManager.getLangWord("YES")}
          </Button>
          <Button
            onClick={() => this.optionDialogStartPPT(false)}
            color="secondary"
            autoFocus
          >
            {languageManager.getLangWord("NO")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    stateLoadingPresentation:
      state.containers.appReducer.stateLoadingPresentation
  };
};
export default connect(mapStateToProps)(DialogUpload);



// WEBPACK FOOTER //
// ./src/containers/components/DialogUpload.js